import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/user/loginv2.vue'),
    meta: {
      title: '登录',
      hideCopyRight: true,
    },
  },
  {
    path: '/passport',
    name: 'Passport',
    component: () => import('@/views/user/passport.vue'),
    meta: {
      hidden: true,
    },
  },
  // {
  //   path: '/login2',
  //   name: 'Login2',
  //   component: () => import('../views/user/loginv2.vue'),
  //   meta: {
  //     title: '微信登录',
  //   },
  // },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import('../views/user/register.vue'),
  //   meta: {
  //     title: '注册',
  //   },
  // },
  {
    path: '/legalagreement',
    name: 'LegalAgreement',
    component: () => import('../views/user/legalAgreement.vue'),
    meta: {
      title: '用户服务协议',
      hideCopyRight: true,
    },
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('../views/user/privacyPolicy.vue'),
    meta: {
      title: '隐私政策',
      hideCopyRight: true,
    },
  },
  {
    path: '/saveimg',
    name: 'SaveImg',
    component: () => import('../views/user/saveimg.vue'),
    meta: {
      title: '保存图片',
    },
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../layout/index.vue'),
    meta: {
      title: '测评',
    },
    children: [
      {
        path: 'do/:id',
        name: 'TestDo',
        component: () => import('../views/test/do.vue'),
        meta: {
          title: '测评',
        },
      },
      {
        path: 'dispatch/:id',
        name: 'dispatch',
        component: () => import('../views/test/do.vue'),
        meta: {
          title: '测评',
        },
      },
    ],
  },
  {
    path: '/crm',
    name: 'Crm',
    component: () => import('../layout/index.vue'),
    meta: {
      title: '客户',
    },
    children: [
      {
        path: 'getInfo',
        name: 'GetInfo',
        component: () => import('../views/crm/getInfo.vue'),
        meta: {
          title: '客户档案',
          copyRight: '客户云',
        },
      },
    ],
  },
  {
    path: '/survey',
    name: 'Survey',
    component: () => import('../layout/index.vue'),
    meta: {
      title: '问卷',
    },
    children: [
      // {
      //   path: 'list',
      //   name: 'SurveyList',
      //   component: () => import('../views/survey/mySurvey.vue'),
      //   meta: {
      //     title: '问卷列表',
      //   },
      // },

      {
        path: 'detail/:id',
        name: 'SurveyDetail',
        component: () => import('../views/survey/detail.vue'),
        meta: {
          title: '问卷详情',
        },
      },
      {
        path: 'dispatch/:id',
        name: 'SurveyDispatch',
        component: () => import('../views/survey/dispatch.vue'),
        meta: {
          title: '问卷详情',
        },
      },
      {
        path: 'answer/:id',
        name: 'AnswerDetail',
        component: () => import('../views/survey/answerDetail.vue'),
        meta: {
          title: '作答详情',
        },
      },
      {
        path: 'mysurvey',
        name: 'MySurvey',
        component: () => import('../views/survey/mySurvey.vue'),
        meta: {
          title: '我的咨询单',
        },
      },
      {
        path: 'agreement',
        name: 'Agreement',
        component: () => import('../views/survey/agreement.vue'),
        meta: {
          title: '签署协议',
          copyRight: '销售云',
          hideCopyRight: true,
        },
      },

      {
        path: 'answerComplete',
        name: 'answerComplete',
        component: () => import('../views/survey/answerComplete.vue'),
        meta: {
          title: '您已完成提交，感谢您的帮助与支持',
        },
      },
      {
        path: 'fastDeal',
        name: 'FastDeal',
        component: () => import('../views/survey/fastDeal.vue'),
        meta: {
          title: '用户激活',
        },
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
